<div class="help-panel flex flex-col h-full">
  <!-- Header -->
  <div class="flex items-center justify-between p-4 border-b">
    <div class="flex items-center gap-1 min-w-0">
      <button *ngIf="canGoBack"
              mat-icon-button
              (click)="back()"
              [attr.aria-label]="'KNOWLEDGE.BACK' | translate"
              [matTooltip]="'KNOWLEDGE.BACK' | translate">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h3 class="text-lg font-semibold m-0 truncate">{{ 'KNOWLEDGE.HELP' | translate }}</h3>
    </div>
    <div class="flex items-center gap-1">
      <button *ngIf="view !== 'overview'"
              mat-icon-button
              (click)="openOverview()"
              [attr.aria-label]="'KNOWLEDGE.OVERVIEW' | translate"
              [matTooltip]="'KNOWLEDGE.OVERVIEW' | translate">
        <mat-icon>menu_book</mat-icon>
      </button>
      <button mat-icon-button
              (click)="close()"
              [attr.aria-label]="'KNOWLEDGE.CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Overview: all topics of the BackOffice, searchable (DOCU-914) -->
  <div *ngIf="view === 'overview'" class="flex flex-col flex-1 min-h-0">
    <div class="p-4 pb-2">
      <div class="flex items-center gap-2 border rounded px-3 py-2">
        <mat-icon class="text-gray-400">search</mat-icon>
        <input type="search"
               class="flex-1 border-0 outline-none bg-transparent text-sm"
               [(ngModel)]="searchTerm"
               [attr.aria-label]="'KNOWLEDGE.SEARCH' | translate"
               [placeholder]="'KNOWLEDGE.SEARCH_PLACEHOLDER' | translate">
      </div>
    </div>

    <div *ngIf="filteredEntries.length === 0"
         class="flex items-center justify-center flex-1 p-6 text-center text-gray-400">
      {{ 'KNOWLEDGE.NO_RESULTS' | translate }}
    </div>

    <div class="flex-1 overflow-auto px-4 pb-4">
      <button *ngFor="let item of filteredEntries"
              type="button"
              class="w-full text-left p-3 mb-2 border rounded hover:bg-gray-50 cursor-pointer"
              (click)="openRelated(item.id)">
        <div class="font-medium text-gray-900">{{ item.title }}</div>
        <div class="text-sm text-gray-500">{{ item.summary }}</div>
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="view === 'entry' && loading" class="flex items-center justify-center flex-1">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <!-- No Content -->
  <div *ngIf="view === 'entry' && !loading && !entry" class="flex items-center justify-center flex-1 p-6 text-center text-gray-400">
    {{ 'KNOWLEDGE.NO_CONTENT' | translate }}
  </div>

  <!-- Content -->
  <div *ngIf="view === 'entry' && !loading && entry" class="flex-1 overflow-auto p-4 space-y-4">
    <!-- Title & Summary -->
    <div>
      <h2 class="text-xl font-bold m-0">{{ entry.title }}</h2>
      <p class="text-gray-500 mt-1 mb-0">{{ entry.summary }}</p>
    </div>

    <!-- Content Blocks -->
    <ng-container *ngFor="let block of entry.contentBlocks">
      <!-- Text -->
      <p *ngIf="block.type === 'text'" class="text-gray-700 leading-relaxed m-0">
        {{ block.text }}
      </p>

      <!-- Steps -->
      <div *ngIf="block.type === 'steps' && block.steps" class="space-y-3">
        <h4 class="text-sm font-semibold text-gray-600 uppercase tracking-wide m-0">
          {{ 'KNOWLEDGE.STEPS' | translate }}
        </h4>
        <ol class="list-none p-0 m-0 space-y-2">
          <li *ngFor="let step of block.steps" class="flex gap-3">
            <span class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-xs font-bold">
              {{ step.order }}
            </span>
            <div>
              <div class="font-medium text-gray-900">{{ step.title }}</div>
              <div class="text-sm text-gray-500">{{ step.description }}</div>
            </div>
          </li>
        </ol>
      </div>

      <!-- Note -->
      <div *ngIf="block.type === 'note'" class="bg-blue-50 border-l-4 border-blue-400 p-3 rounded-r">
        <p class="text-sm text-blue-800 m-0">{{ block.text }}</p>
      </div>

      <!-- Warning -->
      <div *ngIf="block.type === 'warning'" class="bg-amber-50 border-l-4 border-amber-400 p-3 rounded-r">
        <p class="text-sm text-amber-800 m-0">{{ block.text }}</p>
      </div>
    </ng-container>

    <!-- Related Entries -->
    <div *ngIf="entry.relatedEntryIds && entry.relatedEntryIds.length > 0" class="pt-4 border-t">
      <h4 class="text-sm font-semibold text-gray-600 uppercase tracking-wide m-0 mb-2">
        {{ 'KNOWLEDGE.RELATED' | translate }}
      </h4>
      <div class="flex flex-wrap gap-2">
        <!-- DOCU-935: kein color="primary" — die Primary-Palette ist das Sidebar-Grau
             #e0dfde, das faerbt beim Stroked-Button die Beschriftung und laesst den
             Button deaktiviert aussehen. Farbe kommt aus .related-topic (SCSS). -->
        <button *ngFor="let relId of entry.relatedEntryIds"
                mat-stroked-button
                class="related-topic text-sm"
                (click)="openRelated(relId)">
          {{ titleOf(relId) }}
        </button>
      </div>
    </div>

    <!-- Last Updated -->
    <div *ngIf="entry.lastUpdated" class="text-xs text-gray-400 pt-2">
      {{ 'KNOWLEDGE.LAST_UPDATED' | translate }}: {{ entry.lastUpdated | date:'mediumDate' }}
    </div>
  </div>
</div>
